export default __webpack_public_path__ + "static/pint-7211ee48b5f4658305ffb70840d9ea4d.png";